<h2>Job #{{ project.id }} on hold zetten</h2>
<div class="upper-space">
  <textarea-input
    [subtitle]="'Reden waarom on hold (verplicht)'"
    [placeholder]="'Geef hier de reden in'"
    [initContent]="onHoldReason"
    (answer)="onHoldReasonChanged($event)"
  >
  </textarea-input>
</div>
<div class="button-container">
  <ng-container *ngIf="!submitting">
    <button class="btn close-button" (click)="closeDialog()">
      Sluiten
    </button>
    <button
      mat-button
      class="summary-dialog-button confirm-button"
      (click)="confirmOnHold()"
    >
      On hold zetten
    </button>
  </ng-container>
  <ng-container *ngIf="submitting">
    <mat-spinner color="primary" diameter="48"></mat-spinner>
  </ng-container>
</div>
